export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',

  // EDI MessageStatusTag
  'component.messageStatus.delivered': '已投递',
  'component.messageStatus.sent': '已发送',
  'component.messageStatus.received': '已接收',
  'component.messageStatus.parsed': '已解析',
  'component.messageStatus.validatedIn': '入站已校验',
  'component.messageStatus.created': '已创建',
  'component.messageStatus.validatedOut': '出站已校验',
  'component.messageStatus.sending': '发送中',
  'component.messageStatus.parseFailed': '解析失败',
  'component.messageStatus.rejectedIn': '入站拒绝',
  'component.messageStatus.rejectedOut': '出站校验失败',
  'component.messageStatus.deliverFailed': '投递失败',
  'component.messageStatus.sendFailed': '发送失败',
  'component.messageStatus.replayPending': '待重放',
  'component.messageStatus.retryPending': '待重试',

  'component.messageStatus.ackType.transport': '传输',
  'component.messageStatus.ackType.syntax': '语法',
  'component.messageStatus.ackType.app': '应用',

  'component.messageStatus.ackStatus.waiting': '等待中',
  'component.messageStatus.ackStatus.timeout': '超时',
  'component.messageStatus.ackTooltip.waiting': '等待{type}回执中',
  'component.messageStatus.ackTooltip.waitingDeadline':
    '等待{type}回执 (截止: {deadline})',
  'component.messageStatus.ackTooltip.timeout': '回执超时截止于: {deadline}',
  'component.messageStatus.ackTooltip.unknown': '未知',
  'component.messageStatus.ackTooltip.rejectReason': '拒绝原因: {reason}',
  'component.messageStatus.ackTooltip.rejected': '回执异常/拒绝',
};
